import PageSpin from "./PageSpin"

export default PageSpin
